module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABSElEQVQYGZXBu0sUcBwA8O8tdhmKFSJlDRkItRRkrjV0RC0FtRZo0GOroYYaLkipNoOCmgp6rAU9KDnOwT/AOtMbHKxIODODHnZcyyd/5w0iLn4+sWbaXDZt2hUbYzW63fXbiOOOKfrjnu5YziEvVT2yNxrs8dBfr+RiiYJZ13XECjrkVRQj8cmIozKxgowjij5HYpOrZpRdsCEaNDuvbMY1myOR1W/crLIfbttum1vmTfqmpM+6SEz4oF9WxmFv/FPzWi5C1hklpUiUTDhrfdTpsiPqNDtn0lgkmpz23neDOqNBp5vmjTmlKRLt8io+eqfmqf16PVMzbFxFXnskvijIxSK73LdgwQO7Y5Gcgq+ReGvOgK1Rp0VL1NnihjnDscQBz1U90RMN9nms6oWDsZwuQ34addIJo365Y2esRquLpky5pDXW6j/irgQqi+J+FAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/lsNavIcon/jcIcon.png
// module id = NU9R
// module chunks = 95